var map = {
	"./promo/Mantera_promo.mp4": "9e25",
	"./promo/mantera_preview.png": "5c9e",
	"./promo/mantera_preview_2.png": "096a",
	"./promo/mantera_promo_2.mp4": "9f07",
	"./promo/video.mp4": "25ef",
	"./promo/video_preview.png": "33ec",
	"./v_alerts_en.mp4": "e326",
	"./v_coffeeshop.mp4": "a45c",
	"./v_kebab_de.mp4": "0dd6",
	"./v_kebab_en.mp4": "38de",
	"./v_kebab_ru.mp4": "8244",
	"./v_kebab_ua.mp4": "256a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a9f";